
import Vue from 'vue'

import { candidateApi } from '@/api'
import { Candidate, CandidatePartyEnum } from '@/api/candidate'

const defaultCandidate: Candidate = {
  firstName: '',
  lastName: '',
  party: CandidatePartyEnum.DEMOCRAT,
  cycle: '2020',
  nationalPollingAverage: 0.0
}

export default Vue.extend({
  name: 'AddCandidate',
  data() {
    return {
      CandidatePartyEnum,
      candidate: { ...defaultCandidate }
    }
  },
  methods: {
    async submitCandidate() {
      await candidateApi.addCandidate(this.candidate)
      this.$emit('candidateAdded')
      this.candidate = { ...defaultCandidate }
    }
  }
})
